import { Link } from '@inertiajs/react'

interface Props {
  name: string
  description: string
  href: string
  status: string
}

export default function AgentCard({ name, description, href, status }: Props) {
  const isComingSoon = status.toLowerCase() === 'coming soon'

  return (
    <div className={`bg-white border border-gray-200 rounded-2xl p-6 flex flex-col gap-4 hover:border-gray-300 transition-colors ${isComingSoon ? 'cursor-default' : 'cursor-pointer'}`}>
      <div className="flex items-start justify-between gap-3">
        <h3 className="text-gray-900 font-semibold text-lg leading-snug">{name}</h3>
        <span className={`shrink-0 inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ${
          status === 'Live'
            ? 'bg-emerald-500/10 text-emerald-400 ring-emerald-500/20'
            : 'bg-amber-500/10 text-amber-400 ring-amber-500/20'
        }`}>
          {status}
        </span>
      </div>
      <p className="text-gray-500 text-sm leading-relaxed flex-1">{description}</p>
      <div>
        {isComingSoon ? (
          <span className="inline-flex items-center text-sm text-gray-400 cursor-default">
            Coming soon
          </span>
        ) : (
          <Link
            href={href}
            className="inline-flex items-center gap-1.5 rounded-lg bg-brand hover:bg-brand-dark px-4 py-2 text-sm font-medium text-white transition-colors"
          >
            Open Demo
          </Link>
        )}
      </div>
    </div>
  )
}
